import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Loading } from '~/components';
import { FormCad } from '../components';
import initialData from './initialData';
import schema from './schema'
import { Button } from 'react-bootstrap';
import { updateIndicadorAmbiental, loadIndicadoresAmbientais, showIndicadorAmbiental  } from '~/store/modules/indicadorAmbiental/action';


const Edit = () => {
  let history = useHistory();
  const [IndicadorEdit, setIndicadorEdit] = useState(initialData);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const { atividade_id, indicador_ambiental_id } = useParams();
  const { indicador_ambiental, errors } = useSelector(({ IndicadorAmbientalReducer }) => IndicadorAmbientalReducer);

  useEffect(() => {
    dispatch(showIndicadorAmbiental(indicador_ambiental_id, {
        with: 'indicadores_ods'
    }));
  }, [dispatch, indicador_ambiental_id]);

  useEffect(() => {
    if (indicador_ambiental.id === parseInt(indicador_ambiental_id)) {
      setIndicadorEdit(indicador_ambiental);
    }
  }, [indicador_ambiental, indicador_ambiental_id]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setUpdated(true);
    }
  }, [errors]);

  useEffect(() => {
    if (updated) {
      Swal.fire('Sucesso', 'Registro atualizado com sucesso!', 'success').then(
        () => {
          history.goBack();
        }
      );
    }
  }, [updated, history, dispatch, atividade_id]);

  const handleClose = () => {
    history.goBack();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(IndicadorEdit)) {
      let yup_errors = {};
      schema.validate(IndicadorEdit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(updateIndicadorAmbiental(IndicadorEdit, indicador_ambiental_id));
      await dispatch(loadIndicadoresAmbientais({
        where: `atividade_id:${atividade_id}`,
        with_trashed: true,
      }));
      await setUpdated(true);
    }

  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Indicadores Ambientais da Atividade</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {indicador_ambiental.id === parseInt(indicador_ambiental_id) ? (
              <FormCad
                errors={errorsValidate}
                handleSubmit={handleSubmit}
                indicadorAmbiental={IndicadorEdit}
                schema={schema}
                setIndicadorAmbiental={setIndicadorEdit}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-default"
          onClick={handleClose}
        >
          <i className="fa fa-window-close" /> Cancelar
        </Button>
        <button
          className="btn btn-success"
          form="form_indicadorAmbiental"
          type="submint"
        >
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
